import styled from "styled-components";
import { HeadLine1 } from "../../../components/typography/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 30px 60px 30px;
  /* height:100%; */
  /* box-sizing: border-box; */
  position: relative;

  @media (max-width: 768px) {
    width: 100%;
    min-width: 0;
    padding: 10px 16px 40px;
    box-sizing: border-box;
  }
`
export const TitleBig = styled(HeadLine1)`
  color:${({theme}) => theme.palette[850]};
  margin-top: 20px;
`
